<template>
  <!--      popper-class="form-control"-->
  <div class="col-auto">
    <label class="d-inline-block pr-1">{{ $t('navbar.operatorSelectLbl') }}</label>
    <span class="d-inline-block">
    <el-select
      class="select-primary"
      size="large"
      name="operator"
      v-model="operatorId"
      @change="operatorChanged"
    >
      <el-option
        v-for="option in details.assigned_operators"
        class="select-primary"
        :value="option.id"
        :label="option.id"
        :key="option.id"
      >
        <span>{{ option.name }} ({{ option.id }})</span>
      </el-option>
    </el-select>
    </span>
  </div>
</template>
<script>

import {Option, Select} from "element-ui";
import {mapActions, mapState} from "vuex";

export default {
  name: 'operator-select',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      operatorId: '',
    }
  },
  computed: {
    ...mapState({
      selectedReportOperator: state => state.profile.selectedReportOperator,
    }),
    details: function () {
      const user = this.$auth.user()
      return user ? user : {};
    }
  },
  methods: {
    ...mapActions(['SetProfileSelectedReportOperator']),
    setOperatorInUrl(operatorID) {
      const removeKey = (key, {[key]: _, ...rest}) => rest;
      let tmp = removeKey("operator", this.$route.query)
      this.$router.replace({
        query: Object.assign({}, tmp, {
          operator: operatorID
        })
      });
    },
    operatorChanged() {
      const operatorId = this.operatorId
      let operator = this.details.assigned_operators.find(function (el) {
        return el.id === operatorId
      })

      this.SetProfileSelectedReportOperator(operator)
      this.setOperatorInUrl(operatorId)
    },
    getOperator(obj) {
      let operator = null;
      // Provided object is not operator
      if (obj == null) {
        return
      }

      if (!obj.id) {
        return null
      }

      // Verify, that provided operator is available for the logged user.
      if (this.details.assigned_operators) {
        operator = this.details.assigned_operators.find(elem => {
          return elem.id === obj.id
        })

        if (operator) {
          this.operatorId = operator.id
          return operator
        }
      }

      return null
    }
  },
  mounted() {
    let operator = null

    // Get from URL
    operator = this.getOperator({id: this.$route.query.operator})
    if (operator != null) {
      this.SetProfileSelectedReportOperator(operator)
      return
    }

    if (this.$route.query.operator) {
      // Operator in URL exist, but not assigned for user. User must ,manually change operator.
      return;
    }

    operator = this.getOperator(this.selectedReportOperator)
    if (operator) {
      this.SetProfileSelectedReportOperator(operator)
      this.setOperatorInUrl(operator.id)
      return
    }

    if (this.details.assigned_operators.length == 1) {
      // For single assigned operator, it must be selected automatically
      operator = this.details.assigned_operators[0]
      this.SetProfileSelectedReportOperator(operator)
      this.setOperatorInUrl(operator.id)
      this.operatorId = operator.id
      return
    }

    this.SetProfileSelectedReportOperator(null)
  },
};
</script>
